/**
 * Blog Categories API service
 */

import { fetchStrapi, type StrapiResponse } from './strapi';

export interface BlogCategory {
  id: number;
  name: string;
  slug: string;
  order: number;
}

export type BlogCategoriesResponse = StrapiResponse<BlogCategory[]>;

/**
 * Fetch all blog categories from Strapi
 */
export async function fetchBlogCategories(): Promise<BlogCategory[]> {
  try {
    const response = await fetchStrapi<BlogCategoriesResponse>(
      '/blog-categories?sort=reihenfolge:asc'
    );

    if (!response.data) {
      return [];
    }

    return response.data.map((item: any) => ({
      id: item.id,
      name: item.name || '',
      slug: item.slug || '',
      order: item.reihenfolge || 0,
    }));
  } catch (error) {
    console.error('Error fetching blog categories from Strapi:', error);
    return [];
  }
}


